import React, { DetailedHTMLProps, TextareaHTMLAttributes, JSX} from 'react';
import { merge } from '../../helpers/classes';

/**
 *
 */
export const Textarea = (
  props: DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >,
): JSX.Element => {
  const { className, ...rest } = props;

  return (
    <textarea
      className={merge(
        'w-full rounded-sm border-transparent bg-gray-200 p-[0.9em] text-slate-800 dark:bg-gray-800 dark:text-slate-100',
        className,
      )}
      {...rest}
    />
  );
};

export default Textarea;
